// Spanish translation

const es = {
  "menu.hotel_frontdesk": "FRONTDESK",
  "hotel.frontdesk": "Frontdesk",
  "hotel.frontdesk.summary": "Rooms Summary",
  "hotel.frontdesk.guests": "Guests",
  "hotel.frontdesk.end_day": "End of Day Projection",
  "hotel.frontdesk.previous_day": "Previous Day",
  "hotel.frontdesk.pending": "Pendiente",
  "hotel.guests_list.report": "Lista de Huespedes",
  "hotel.guests_list.filter": "Filtro",
  "hotel.guests_list.date": "Fecha",
  "hotel.guests_list.operation_center": "Centro de Operaciones",
  "hotel.guests_list.only_main_guest": "Solo Huesped Principal",
  "hotel.rooms_occupancy.report": "Ocupación de Habitaciones",
  "hotel.rooms_occupancy.filter": "Filtro",
  "hotel.rooms_occupancy.date": "Fecha",
  "hotel.rooms_occupancy.operation_center": "Centro de Operaciones",
  "hotel.rooms_occupancy.only_main_guest": "Solo Huesped Principal",
  "hotel.folio.add_night.msg_start":
    "Esta seguro que quiere agregar una noche adicional al folio?",
  "hotel.folio.add_night": "Noche",
  "hotel.folio.add_night.msg_success": "Noche agregada exitosamente",
  "hotel.folio.update": "Actualizar",
  "hotel.folio.add_payment": "Agregar Pago",
  "hotel.folio.update.arrival_date": "Llegada",
  "hotel.folio.update.departure_date": "Salida",
  "hotel.folio.update.unit_price": "Precio Unitario",
  "hotel.folio.update.overbooking": "Sobreventa",
  "hotel.folio.update.product": "Acomodación",
  "hotel.folio.update.room": "Habitación",
  "hotel.folio.guest.main_guest": "Huesped Principal",
  "hotel.folio.guest.name": "Nombre",
  "hotel.folio.guest.mobile": "Movil",
  "hotel.folio.guest.email": "Correo Electronico",
  "hotel.folio.guest.address": "Direccion",
  "hotel.folio.guest.nationality": "Nacionalidad",
  "hotel.folio.guest.country_residence": "Pais de Residencia",
  "hotel.folio.guest.sex": "Sexo",
  "hotel.folio.guest.type_guest": "Tipo de Huesped",
  "hotel.folio.guest.id_number": "Numero de ID.",
  "hotel.folio.guest.type_document": "Tipo de Documento",
  "hotel.folio.guest.birthday": "Fecha de Nacimiento",
  "hotel.folio.guest.profession": "Profesion",
  "hotel.folio.guest.folio": "Folio",
  "hotel.folio.party_holder": "Titular",
  "hotel.folio.comments": "Comentarios",
  "hotel.housekeeping.operation_center": "Centro de Operaciones",
  "hotel.housekeeping.employee": "Empleado",
  "hotel.housekeeping.date": "Fecha",
  "hotel.print_housekeeping.report": "Reporte Ama de Llaves",
  "hotel.housekeeping.grouped_by_employee": "Agrupar por Empleado",
  "hotel.guests_list.show_guests": "Mostrar Huesped",
  "hotel.operation_forecast.report": "Operation Forecast",
  "hotel.operation_forecast.fiscalyear": "Año fiscal",
  "hotel.operation_forecast.operation_center": "Centro de Operaciones",
  "hotel.operation_forecast.period":"Periodo",



};

export default es;
